import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Account } from '@personal-area/global/accounts/models';
import { EventType } from '@personal-area/global/gtm';
import { LoadingState } from '@personal-area/global/state';

import { PasswordComponentStore } from './account-viewer-password.component.store';

@Component({
    selector: 'global-account-viewer-password',
    templateUrl: './account-viewer-password.component.html',
    styleUrls: ['./account-viewer-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [PasswordComponentStore],
    standalone: false
})
export class AccountViewerPasswordComponent implements OnChanges {
  @Input() account!: Account;
  public passwordState$ = this._componentStore.loadingState$;
  public password$ = this._componentStore.password$;
  readonly eventType = EventType;
  readonly LoadingState = LoadingState;

  constructor(private _componentStore: PasswordComponentStore) {
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['account'].currentValue?.id !== changes['account'].previousValue?.id
      || changes['account'].firstChange) {
      this._componentStore.getPassword(this.account);
    }
  }

  public generatePassword(): void {
    this._componentStore.generatePassword(this.account);
  }
}
